/**
 * Format a reporting period for the Ongoing Reporting tab (#4800) from a field's
 * carry-forward source: its `asOfDate` (the period-END date) + `periodType`. Used by
 * {@link FieldPeriodStamp} to show "Last updated for Q1 2025" so an analyst viewing a
 * later period can tell which period the displayed value was actually authored for.
 *
 * The date is parsed in UTC: the backend stores the period-end at UTC midnight (e.g.
 * "2026-03-31T00:00:00.000Z"), so reading local components could drift into the wrong
 * quarter/year in timezones behind UTC. UTC components are exact and timezone-stable.
 */
const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export function formatReportingPeriod(
  asOfDate: Date | string | null | undefined,
  periodType: string | null | undefined
): string | null {
  if (!asOfDate || !periodType) return null;
  const date = typeof asOfDate === "string" ? new Date(asOfDate) : asOfDate;
  if (Number.isNaN(date.getTime())) return null;

  const year = date.getUTCFullYear();
  const monthIndex = date.getUTCMonth(); // 0-11

  switch (periodType) {
    case "quarter":
      return `Q${Math.floor(monthIndex / 3) + 1} ${year}`;
    case "month":
      return `${MONTH_NAMES[monthIndex]} ${year}`;
    case "year":
      return `${year}`;
    default:
      return null;
  }
}
